import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GetLevelOneApi } from "../LevelOne/LevelOneAction";
import { GetLevelTwoWithLevelOneIDApi } from "../LevelTwo/LevelTwoAction";
import { AddLevelFourApi, GetLevelAccountTypeApi } from "./LevelFourAction";
import { setHeading } from "../../../accounts/account.actions";
import { GetLevelThreeWithLevelTwoIDApi } from "../LevelThree/LevelThreeAction";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from 'react-select';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddLevelFour = (props) => {
    const [levelOneId, setLevelOneId] = useState();
    const [levelOneName, setLevelOneName] = useState();
    const [levelTwoId, setLevelTwoId] = useState();
    const [levelTwoName, setLevelTwoName] = useState();
    const [levelThreeId, setLevelThreeId] = useState();
    const [levelThreeName, setLevelThreeName] = useState();
    const [levelFourName, setLevelFourName] = useState();
    const [levelBalance, setLevelFourBalance] = useState();
    const [accountTypeId, setAccountTypeId] = useState();
    const [accountTypeName, setAccountTypeName] = useState();


    function SaveLevelFour() {
        props.AddLevelFourApi({
            levelOneId: levelOneId,
            levelOneName: levelOneName,
            levelTwoId: levelTwoId,
            levelTwoName: levelTwoName,
            levelThreeId: levelThreeId,
            levelThreeName: levelThreeName,
            levelFourName: levelFourName,
            levelBalance: levelBalance,
            accountTypeId: accountTypeId,
            accountTypeName: accountTypeName,
        },
            showSuccessAlert,
            showErrorAlert
        );
        setLevelOneId("")
        setLevelTwoId("")
        setLevelThreeId("")
        setLevelFourName("")
        setLevelFourBalance("")
        setAccountTypeId("")
    }


    const handleChangeLevelOne = (selectedOption) => {
        setLevelOneId(selectedOption.value);
        setLevelOneName(selectedOption.label);
        props.GetLevelTwoWithLevelOneIDApi(selectedOption.value)
    };
    const getLevelOneList = props.levelOneList?.data?.length ? props.levelOneList.data.map(x => ({
        value: x._id,
        label: `${x.key} - ${x.name}`,
    })) : [];


    const handleChangeLevelTwo = (selectedOption) => {
        setLevelTwoId(selectedOption.value);
        setLevelTwoName(selectedOption.label);
        props.GetLevelThreeWithLevelTwoIDApi(selectedOption.value)
    };
    const getLevelTwoList = props.levelTwoWithLevelOneIdList?.length ? props.levelTwoWithLevelOneIdList.map(x => ({
        value: x._id,
        label: `${x.allKey} - ${x.levelTwoName}`,
    })) : [];


    const handleChangeLevelThree = (selectedOption) => {
        setLevelThreeId(selectedOption.value);
        setLevelThreeName(selectedOption.label);
        props.GetLevelThreeWithLevelTwoIDApi(selectedOption.value)
    };
    const getLevelThreeList = props.levelThreeWithLevelTwoIdList?.length ? props.levelThreeWithLevelTwoIdList.map(x => ({
        value: x._id,
        label: `${x.allLevlKey} - ${x.levelThreeName}`,
    })) : [];


    const handleChangeAccountType = (selectedOption) => {
        setAccountTypeId(selectedOption.value);
        setAccountTypeName(selectedOption.label);
    };
    const getAccountTypeList = !_.isEmpty(props.accountTypeList) && props.accountTypeList.map((x) => {
        let data = { value: x._id, label: x.account_type_name };
        return data;
    });


    useEffect(() => {
        props.GetLevelOneApi();
        props.GetLevelAccountTypeApi();
        props.setHeading("Add Level Four");
    }, []);

    return (
        <>
            {props.isFetchingLevelOne || props.isAddingLevelFour || props.isFetchingAccountType ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 1 *</b></Form.Label>
                                <Select
                                    placeholder="Select Level 1"
                                    onChange={handleChangeLevelOne}
                                    options={getLevelOneList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 2 *</b></Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(levelOneId)}
                                    placeholder="Select Level 2"
                                    onChange={handleChangeLevelTwo}
                                    options={getLevelTwoList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 3 *</b></Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(levelTwoId)}
                                    placeholder="Select Level 3"
                                    onChange={handleChangeLevelThree}
                                    options={getLevelThreeList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Account Type *</b></Form.Label>
                                <Select
                                    placeholder="Select Account Type"
                                    onChange={handleChangeAccountType}
                                    options={getAccountTypeList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Level 4 Name *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Level Four Name"
                                    onChange={(e) => setLevelFourName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Account Balance *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Account Balance"
                                    onChange={(e) => setLevelFourBalance(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(levelOneId) || _.isEmpty(levelTwoId) || _.isEmpty(levelThreeId) || _.isEmpty(levelFourName) || _.isEmpty(accountTypeId) || _.isEmpty(levelBalance) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveLevelFour}> SAVE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetLevelThreeWithLevelTwoIDApi: (levelTwoId) => dispatch(GetLevelThreeWithLevelTwoIDApi(levelTwoId)),
        setHeading: (data) => dispatch(setHeading(data)),
        GetLevelAccountTypeApi: () => dispatch(GetLevelAccountTypeApi()),
        GetLevelOneApi: () => dispatch(GetLevelOneApi()),
        GetLevelTwoWithLevelOneIDApi: (levelOneId) => dispatch(GetLevelTwoWithLevelOneIDApi(levelOneId)),
        AddLevelFourApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddLevelFourApi(data, showSuccessAlert, showErrorAlert)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingLevelFour: state.LevelFourReducer.isAddingLevelFour,
    isFetchingLevelOne: state.LevelOneReducer.isFetchingLevelOne,
    levelOneList: state.LevelOneReducer.levelOneList,
    levelTwoWithLevelOneIdList: state.LevelTwoReducer.levelTwoWithLevelOneIdList,
    levelThreeWithLevelTwoIdList: state.LevelThreeReducer.levelThreeWithLevelTwoIdList,
    isFetchingAccountType: state.LevelFourReducer.isFetchingAccountType,
    accountTypeList: state.LevelFourReducer.accountTypeList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddLevelFour);